import CollectionSection from "./collection-section";

class SearchSection extends CollectionSection {
  constructor() {
    super();
  }

  connectedCallback() {
    this._attachEventListeners();

    if (this.dataset.hideOutOfStock === "true" && this.currentUrl.searchParams.get("filter.v.availability") !== "1") {
      this.currentUrl.searchParams.set("filter.v.availability", "1");
    }

    this._fetchLinkResults();
    this._loadSearch(false);
    if (sessionStorage.getItem("defaultFilters")) {
      JSON.parse(sessionStorage.getItem("defaultFilters"))?.filterCheckedItems?.forEach(
        (activeFilter) => {
          this.querySelectorAll(`[id^="${activeFilter}"]`).forEach((activeFilterInput) => {
            activeFilterInput.checked = false;
          });
        }
      );
    }
  }

  _attachEventListeners() {
    let init = false;

    document.addEventListener("search:loaded", () => {
      if (!init) {
        super._attachEventListeners();
        this.querySelector("filter-category-item")?.addEventListener("click", this._onFilterCategoryItemClick.bind(this));

        const clearFilterCategory = this.querySelector("[data-action='clear-filter-category']");
        if (clearFilterCategory) {
          clearFilterCategory.addEventListener("click", this._onFilterCategoryItemClick.bind(this));
          clearFilterCategory.classList.add("js-initialized");
        }

        init = true;
      }
      this._updateEventListeners();
      this._initDefaultListViewMode();
    });
  }

  _loadSearch(callFilters) {
    document.dispatchEvent(
      new CustomEvent("search:page", {
        detail: {
          callFilters: callFilters,
          element: this,
        },
      })
    );
  }

  _onSortByChanged(e) {
    const value = e.target.value;
    this.currentUrl.searchParams.set("sort_by", value);
    this.currentUrl.searchParams["delete"]("page");
    document.dispatchEvent(
      new CustomEvent("search:pageUpdateSorting", {
        detail: {
          sortValue: value,
        },
      })
    );
    this._loadSearch(false);
  }

  _onShowingCountChanged(e) {
    const value = parseInt(e.target.value);
    this.currentUrl.searchParams.delete("page");
    document.dispatchEvent(
      new CustomEvent("search:pageUpdateProductsPerPage", {
        detail: {
          productsPerPage: value,
        },
      })
    );
    this._loadSearch(false);
  }

  _onFilterChanged(e) {
    window.lastCheckedFilter = e.target;

    let queryString = [];

    const priceRange = e.target.closest("price-range");
    let storedFilter = sessionStorage.getItem("`default`Filters");
    let storedFilterJSON =
      storedFilter && storedFilter !== ""
        ? JSON.parse(sessionStorage.getItem("defaultFilters") || "{}")
        : {};

    console.log("price range", priceRange?.minValue, priceRange?.maxValue);
    const setMaxBtns = this.querySelectorAll(".js-set-max");
    setMaxBtns.forEach((btn) => {
      const maxValue = btn.getAttribute("data-max");
      if (maxValue > priceRange?.maxValue) {
        btn.querySelector("div").classList.add("!jc-bg-gray-300", "jc-border-gray-300");
      } else {
        btn.querySelector("div").classList.remove("!jc-bg-gray-300", "jc-border-gray-300");
      }
    });

    if (priceRange) {
      queryString.push(`(price: IN(${priceRange.minValue}i, ${priceRange.maxValue}e))`);
    } else if (
      storedFilter != "" &&
      storedFilterJSON?.filterPrice?.maxValue &&
      storedFilterJSON?.filterPrice?.minValue
    ) {
      queryString.push(
        `(price: IN(${storedFilterJSON.filterPrice.minValue}i, ${storedFilterJSON.filterPrice.maxValue}e))`
      );
    }

    this.querySelectorAll("filter-block").forEach((el) => {
      const filterBrandsArray = [
        ...new Set(
          Array.from(el.querySelectorAll('[name^="filter."]:checked')).map(
            (filter) => `\"${filter.value}\"`
          )
        ),
      ].join(",");
      if (filterBrandsArray.length != 0) {
        if (el.id === "attributes.publicationDate") {
          const filteredPublicationDate = filterBrandsArray.replaceAll('"', "").split(",");
          const enterTime = sessionStorage.getItem("enterTime");
          filteredPublicationDate.forEach((filterPublicationDate) => {
            const publicationDateLessOrOver = filterPublicationDate.split("-");

            if (publicationDateLessOrOver[1] == "M") {
              queryString.push(
                `(${el.id}: IN(${publicationDateLessOrOver[0]}i, ${
                  new Date(enterTime).getTime() / 1000
                }e))`
              );
            } else {
              queryString.push(`(${el.id}: IN(0i, ${publicationDateLessOrOver[0]}e))`);
            }
          });
        } else {
          queryString.push(`(${el.id}: ANY(${filterBrandsArray}))`);
        }
      }
    });

    let filterObj = {
      filterCheckedItems: [
        ...new Set(
          Array.from(this.querySelectorAll('[name^="filter."]:checked')).map(
            (filter) => `${filter.id}`
          )
        ),
      ],
      queryString,
      filterPrice: {},
    };

    if (priceRange) {
      filterObj.filterPrice.max = priceRange.max;
      filterObj.filterPrice.maxValue = priceRange.maxValue;
      filterObj.filterPrice.min = priceRange.min;
      filterObj.filterPrice.minValue = priceRange.minValue;
    } else if (
      storedFilter != "" &&
      storedFilterJSON?.filterPrice?.max &&
      storedFilterJSON?.filterPrice?.maxValue &&
      storedFilterJSON?.filterPrice?.min &&
      storedFilterJSON?.filterPrice?.minValue
    ) {
      filterObj.filterPrice.min = storedFilterJSON.filterPrice.min;
      filterObj.filterPrice.minValue = storedFilterJSON.filterPrice.minValue;
      filterObj.filterPrice.max = storedFilterJSON.filterPrice.max;
      filterObj.filterPrice.maxValue = storedFilterJSON.filterPrice.maxValue;
    }

    if (queryString.length > 0) {
      sessionStorage.setItem("defaultFilters", JSON.stringify(filterObj));
    } else {
      sessionStorage.setItem("defaultFilters", "");
    }
    sessionStorage.setItem("currentPage", "");

    this._loadSearch(false);
  }

  _onFilterRemoved(e) {
    if (e.currentTarget.classList.contains("js-reset-price-range")) {
      this.priceRanges.forEach((range) => range.resetInputs());
    }
    if (e.currentTarget.classList.contains("js-clear-filters")) {
      this.querySelectorAll("[name^='filter.']:checked").forEach(
        (input) => (input.checked = false)
      );

      if (sessionStorage.getItem("defaultFilters")) {
        JSON.parse(sessionStorage.getItem("defaultFilters"))?.filterCheckedItems?.forEach(
          (activeFilter) => {
            this.querySelectorAll(`[id^="${activeFilter}"]`).forEach((activeAuthor) => {
              activeAuthor.checked = false;
            });
          }
        );
      }

      sessionStorage.setItem("defaultFilters", "");
      sessionStorage.setItem("categoryFilter", "");
      sessionStorage.setItem("seriesFilterString", "");
    }

    this._loadSearch(false);
  }

  _onPageChanged(e) {
    e.preventDefault();
    document.dispatchEvent(
      new CustomEvent("search:pageUpdatePagination", {
        detail: {
          target: e.currentTarget,
        },
      })
    );
    this._loadSearch(false);
  }

  _onFilterCategoryItemClick(e) {
    sessionStorage.setItem("currentPage", "");
    this._loadSearch(false);
  }

  _updateEventListeners(e) {
    const filterInputs = this.querySelectorAll("[name^='filter.']:not(.js-initialized)");
    filterInputs.forEach((input) => {
      input.addEventListener("change", this._onFilterChanged.bind(this));
      input.classList.add("js-initialized");
    });
    this.paginationBtns.forEach((btn) => {
        btn.addEventListener("click", this._onPageChanged.bind(this));
        btn.classList.add("js-initialized");
      }
    );
    const clearFilterCategory = this.querySelector("[data-action='clear-filter-category']");
    if (clearFilterCategory && !clearFilterCategory.classList.contains("js-initialized")) {
      clearFilterCategory.addEventListener("click", this._onFilterCategoryItemClick.bind(this));
      clearFilterCategory.classList.add("js-initialized");
    }
  }

  async _fetchLinkResults() {
    const searchQuery = this.currentUrl.searchParams.get("q");
    const searchType = window.theme.searchMode.replace("product,", "");
    const fetchUrl = `${window.routes.searchUrl}?section_id=search-content&q=${searchQuery}&type=${searchType}`;

    try {
      const response = await fetch(fetchUrl, {
        credentials: "same-origin",
      });

      const content = await response.text();
      const linkSearchResults = this.querySelector(".js-link-search-results");

      if (linkSearchResults && content.trim() !== "") {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = content;
        linkSearchResults.innerHTML = tempDiv.querySelector(".js-link-search-results").innerHTML;
        linkSearchResults.setAttribute("aria-hidden", false);
      }
    } catch (error) {
      console.error("Error fetching search content:", error);
    }
  }
}

customElements.define("search-section", SearchSection);
